"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishTimeoutEvent = exports.subscribeTimeoutEvent = void 0;
class HMSError extends Error {
    constructor(m) {
        super(m);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, HMSError.prototype);
    }
}
exports.default = HMSError;
const subscribeTimeoutEvent = (error) => {
    return new CustomEvent('subscribeTimeoutEvent', {
        detail: {
            error,
        },
    });
};
exports.subscribeTimeoutEvent = subscribeTimeoutEvent;
const publishTimeoutEvent = (error) => {
    return new CustomEvent('publishTimeoutEvent', {
        detail: {
            error,
        },
    });
};
exports.publishTimeoutEvent = publishTimeoutEvent;
